/* import __COLOCATED_TEMPLATE__ from './content-import-logs-sheet.hbs'; */
/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { action } from '@ember/object';
import Component from '@glimmer/component';

interface Signature {
  Args: {
    model: {
      appId: string;
      sourceId: string;
      sourceType: string;
      onOpenChange: () => void;
    };
  };
}

export default class KnowledgeHubContentImportLogsSheet extends Component<Signature> {
  @action
  onOpenChange() {
    this.args.model.onOpenChange();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::KnowledgeHub::ContentImportLogsSheet': typeof KnowledgeHubContentImportLogsSheet;
    'react/knowledge-hub/content-import-logs-sheet': typeof KnowledgeHubContentImportLogsSheet;
  }
}
